import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React, { memo } from 'react';
import { Button, ButtonVariant } from "../button";
import { Spacer } from "../layout";
import { MessageBanner, MessageBannerType } from "../message-banner";
import { FILE_UPLOAD_ERRORS_SPACING } from "./constants";
import { ErrorsButtonsRow, ErrorsText, FailedFileText } from "./helperComponents";
import { jsx as ___EmotionJSX } from "@emotion/core";
var FileUploadFailedFiles = /*#__PURE__*/memo(function (_ref) {
  var cancelButtonText = _ref.cancelButtonText,
      errorText = _ref.errorText,
      failedFiles = _ref.failedFiles,
      files = _ref.files,
      maxFiles = _ref.maxFiles,
      onFileAttached = _ref.onFileAttached,
      rejectedFilesLength = _ref.rejectedFilesLength,
      renderRejectedErrorText = _ref.renderRejectedErrorText,
      retryButtonText = _ref.retryButtonText,
      setFailedFiles = _ref.setFailedFiles,
      setFiles = _ref.setFiles,
      setRequests = _ref.setRequests,
      uploadHandler = _ref.uploadHandler;
  var hasFailedFiles = failedFiles.length > 0;
  var hasRejectedFiles = rejectedFilesLength > 0 && maxFiles > 0;

  if (!hasFailedFiles && !hasRejectedFiles) {
    return null;
  }

  var handleCancelFailed = function handleCancelFailed() {
    onFileAttached(files);
    setFailedFiles([]);
  };

  var handleRetryFailed = function handleRetryFailed() {
    var filesToUpload = failedFiles;
    setFailedFiles([]);
    setFiles(function (prevState) {
      return [].concat(_toConsumableArray(prevState), _toConsumableArray(filesToUpload));
    });

    if (uploadHandler) {
      uploadHandler({
        files: filesToUpload,
        setFiles: setFiles,
        setFailedFiles: setFailedFiles,
        setRequests: setRequests
      });
    }
  };

  return ___EmotionJSX(React.Fragment, null, hasFailedFiles && ___EmotionJSX(MessageBanner, {
    contentWrapperProps: {
      width: '100%'
    },
    type: MessageBannerType.Error
  }, ___EmotionJSX(ErrorsText, null, errorText), ___EmotionJSX(Spacer, {
    height: FILE_UPLOAD_ERRORS_SPACING
  }), failedFiles.map(function (file, index) {
    return ___EmotionJSX(FailedFileText, {
      key: index
    }, file.name);
  }), ___EmotionJSX(Spacer, {
    height: FILE_UPLOAD_ERRORS_SPACING
  }), ___EmotionJSX(ErrorsButtonsRow, null, ___EmotionJSX(Button, {
    onClick: handleCancelFailed,
    variant: ButtonVariant.Tertiary
  }, cancelButtonText), ___EmotionJSX(Button, {
    onClick: handleRetryFailed,
    variant: ButtonVariant.Primary
  }, retryButtonText))), hasRejectedFiles && ___EmotionJSX(MessageBanner, {
    type: MessageBannerType.Error
  }, ___EmotionJSX(ErrorsText, null, renderRejectedErrorText(rejectedFilesLength, maxFiles))));
});
FileUploadFailedFiles.displayName = 'FileUploadFailedFiles';
export default FileUploadFailedFiles;